// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ReportFileStatusSchema = z.enum(['DRAFT','FINAL'] as const);

export type ReportFileStatusType = `${z.infer<typeof ReportFileStatusSchema>}`

export default ReportFileStatusSchema;
